import { observable }        from 'rewire-core';
import timecardTestModel     from './TimecardTestModel';
import timecardTestListModel from './TimecardTestListModel';

export class TimecardTestPageModel {
  constructor() {
  }

  reset() {
    timecardTestModel.reset();
    timecardTestListModel.reset();
  }
}

const timecardTestPageModel = observable(new TimecardTestPageModel());
export default timecardTestPageModel;
